export enum ChallengeType {
    journey = 'JOURNEY',
    biotype = 'BIOTYPE',
    prize = 'PRIZE',
    company = 'COMPANY',
    group = 'GROUP',
    personal = 'PERSONAL'
}
